import React, { useEffect, useRef, useState } from "react";
import Spreadsheet from "react-spreadsheet-component";

const SpreadsheetWithHeaders = ({ initialData, config, cellClasses, prevRowCount = 0 }) => {

    const spreadsheetRef = useRef(null);

    const [colWidths, setColWidths] = useState([]);

    const numRows = initialData?.rows?.length - 1;
    const numCols = initialData?.rows?.[0]?.length || 0;

    function getExcelColumnName(index) {
        let name = "";
        while (index >= 0) {
            name = String.fromCharCode((index % 26) + 65) + name;
            index = Math.floor(index / 26) - 1;
        }
        return name;
    }

    const columnHeaders = Array.from({ length: numCols }, (_, i) =>
        getExcelColumnName(i)
    );

    // After spreadsheet renders, measure column widths
    useEffect(() => {
        if (!spreadsheetRef.current) return;

        const table = spreadsheetRef.current.querySelector("table");
        if (!table) return;

        const firstRowCells = table.querySelector("tr")?.children;
        if (!firstRowCells) return;
        
        const widths = Array.from(firstRowCells).map(
            (cell) => cell.getBoundingClientRect().width
        );
        setColWidths(widths);
    }, [initialData?.rows]);
    
    console.log("cellClasses", cellClasses)

    return (
        <div className="grid grid-cols-[40px_auto] border border-borderSlateGrey bg-white">
            {/* Row numbers */}
            <div className="border-r border-borderSlateGrey">
                <div className="px-5 h-[28px] border-b border-borderSlateGrey" />
                {Array.from({ length: numRows }).map((_, i) => (
                    <>
                        {i === 0 && <div
                            key={i}
                            className="h-[32px] flex items-center justify-center border-b border-borderSlateGrey bg-[#F3F4F9]"
                            // style={{
                            //     height: 43,
                            //     display: "flex",
                            //     alignItems: "center",
                            //     justifyContent: "center",
                            //     borderBottom: "1px solid #ddd",
                            //     borderRight: "1px solid #ddd",
                            //     background: "#f7f7f7",
                            // }}
                        >
                        </div>}
                        <div
                            key={i}
                            className="h-[32px] flex items-center justify-center border-b border-borderSlateGrey bg-[#F3F4F9] text-xs font-medium text-[#111D31]"
                            // style={{
                            //     height: 38,
                            //     display: "flex",
                            //     alignItems: "center",
                            //     justifyContent: "center",
                            //     borderBottom: "1px solid #ddd",
                            //     borderRight: "1px solid #ddd",
                            //     background: "#f7f7f7",
                            // }}
                        >
                            {i + prevRowCount + 1}
                        </div>
                    </>
                ))}
            </div>

            {/* Main area */}
            <div className="overflow-auto">
                {/* Column headers */}
                <div className="flex">
                    {columnHeaders.map((h, i) => (
                        <div
                            key={i}
                            className={`h-[28px] flex items-center justify-center border-b border-r border-borderSlateGrey text-xs font-medium text-[#111D31] bg-[#F3F4F9] box-border`}
                            style={{
                                width: colWidths[i] || 100, // fallback if not measured yet
                                flex: `0 0 ${colWidths[i] ?? "100"}px`
                            }}
                        >
                            {h}
                        </div>
                    ))}
                </div>

                {/* Actual spreadsheet */}
                <div ref={spreadsheetRef}>
                    <Spreadsheet
                        initialData={initialData}
                        config={config}
                        cellClasses={cellClasses}
                        spreadsheetId="spreadsheet-1"
                    />
                </div>
            </div>
        </div>
    );
};

export default SpreadsheetWithHeaders;
